import i18n from '@/i18n';

export type PreviewLoadingOptions = {
  titleText: string;
  hintText: string;
  tabTitle: string;
};

export function writePreviewLoadingHtml(
  win: Window,
  { titleText, hintText, tabTitle }: PreviewLoadingOptions,
): void {
  const locale = (i18n as unknown as { locale?: string }).locale || 'en';
  win.document.write(`<!DOCTYPE html>
<html lang="${locale}">
<head>
  <meta charset="utf-8">
  <title>${tabTitle}</title>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap" rel="stylesheet">
  <style>
    html, body {
      margin: 0;
      padding: 0;
      height: 100%;
      font-family: 'Poppins', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      background: #ffffff;
      color: #36134a;
    }
    .preview-loading {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;
      padding: 24px;
      text-align: center;
    }
    .preview-loading__spinner {
      width: 44px;
      height: 44px;
      border: 3px solid #E3E1EA;
      border-top-color: #7A2BA8;
      border-radius: 50%;
      animation: preview-spin 0.9s linear infinite;
    }
    .preview-loading__title {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #36134a;
    }
    .preview-loading__hint {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      color: #67646D;
      max-width: 360px;
      line-height: 1.5;
    }
    @keyframes preview-spin {
      to { transform: rotate(360deg); }
    }
  </style>
</head>
<body>
  <div class="preview-loading">
    <div class="preview-loading__spinner" aria-hidden="true"></div>
    <h1 class="preview-loading__title">${titleText}</h1>
    <p class="preview-loading__hint">${hintText}</p>
  </div>
</body>
</html>`);
}
